<template>
    <div>
        <limitless-page-header
            :sub-title="(product && product.ProdID > 0 ? product.ProdName : (not_found ? '????' : 'Ny produkt'))"
            :title-id="(product && product.ProdID > 0 ? product.ProdID : '')"
        >
            <template #header-elements>
                <limitless-page-header-button v-if="product" @click.prevent="openPreview" url="#" icon="icon-file-eye">Förhandgranska</limitless-page-header-button>
            </template>
        </limitless-page-header>

        <div class="content" style="padding-bottom: 6rem;">
            <div v-if="product">
                <div v-if="product.isPhasedOut" class="alert alert-danger">Denna produkt är dold från alla kort! (utgått)</div>
                <div v-else-if="product.isHiddenFromAllCards" class="alert alert-danger">Denna produkt är dold från alla kort! (gömd från alla kort)</div>
                <div v-else-if="product.isOutOfStock && product.no_refill" class="alert alert-danger">Denna produkt är dold från alla kort! (ej refill och slut i lager)</div>
                <div v-else-if="product.show_on_all_cards" class="alert alert-info">Denna produkt visas på alla kort!</div>
            </div>
            <div v-else-if="not_found">
                <i class="text-danger font-italic">Produkten hittades inte...</i>
            </div>
            <div v-else-if="error">
                <i class="text-danger font-italic">Något gick fel, kunde inte hämta data...</i>
            </div>
            <div v-else><i class="icon-spinner2 spinner"></i></div>

            <limitless-card-tabs-view :links="routes" v-show="product">
                <router-view @prductUpdated="getProduct"></router-view>
                <activity-notification v-if="product && product.ProdID > 0" :channel="'product-' + product.ProdID"></activity-notification>
            </limitless-card-tabs-view>
        </div>
    </div>
</template>

<script>
import LimitlessCardTabsView from '@components/Limitless/CardTabsView.vue';
import LimitlessPageHeader from '@components/Layout/partials/LimitlessPageHeader.vue';
import LimitlessPageHeaderButton from '@components/Layout/partials/LimitlessPageHeaderButton.vue';
import ActivityNotification from '@components/User/ActivityNotification.vue';
import apiClient from '@services/ApiClient';

export default {
    name: 'ProductEditor',
    components: {
        LimitlessCardTabsView,
        LimitlessPageHeader,
        LimitlessPageHeaderButton,
        ActivityNotification,
    },
    data: () => ({
        id: null,
        product: null,
        error: false,
        not_found: false,
    }),
    async created() {
        if (this.$route.params.id) {
            this.id = this.$route.params.id;
        }
    },
    watch: {
        '$route.params.id': function watchRouteParamsId(id) {
            this.id = id;
        },
        id: function watchId() {
            this.product = null;
            this.getProduct();
        },
    },
    methods: {
        getProduct() {
            apiClient.get('/vue/products/' + this.id + '/info').then((response) => {
                this.product = response.data.product;
                this.not_found = false;
                this.error = false;
            }).catch((error) => {
                this.product = null;
                if (error.response) {
                    const { status } = error.response;
                    if (status === 404) {
                        this.not_found = true;
                    } else {
                        this.error = true;
                    }
                }
            });
        },
        openPreview() {
            window.open('https://ordergift.se/intranet/product/preview/' + this.product.ProdID, 'prodpreview');
        },
    },
    computed: {
        routes() {
            const { id } = this.$route.params;
            return [
                { name: 'products.edit', params: { id }, text: 'Information' },
                { name: 'products.web', params: { id }, text: 'Web' },
                { name: 'products.pdfinfo', params: { id }, text: 'PDF' },
                { name: 'products.images', params: { id }, text: 'Bilder' },
                { name: 'products.prices', params: { id }, text: 'Priser' },
                { name: 'products.logistics', params: { id }, text: 'Lager' },
                { name: 'products.delivery_statistics', params: { id }, text: 'Lagergrafer' },
                { name: 'products.purchases', params: { id }, text: 'Beställningar' },
                { name: 'products.cards', params: { id }, text: 'Kopplade kort' },
                { name: 'products.delivery_status', params: { id }, text: 'Leveransstatus' },
                { name: 'products.log', params: { id }, text: 'Historik' },
            ];
        },
    },
};
</script>
